import { useEffect } from "react";
import { connect } from "react-redux";
import { initSessions, initSession, startSession, toggleBookmark } from "actions/sessionAction";
import SessionIntroduction from "views/session/SessionIntroduction";
import { useParams } from "react-router-dom";

const SessionIntroductionContainer = ({
  allSessions,
  mySessions,
  currentSession,
  sessionProgress,
  initSessions,
  initSession,
  startSession,
  toggleBookmark,
  ...props
}) => {
  const { sessionId } = useParams();

  useEffect(() => {
    if (sessionId) {
      initSession(sessionId, true);
      initSessions();
    } else {
      initSessions();
    }
  }, [sessionId, initSessions, initSession]);

  // The page carries its own placeholders, so an empty list is handed straight
  // through rather than swapped for a line of text.
  return (
    <SessionIntroduction
      {...props}
      allSessions={allSessions}
      mySessions={mySessions}
      currentSession={currentSession}
      sessionProgress={sessionProgress}
      initSession={initSession}
      startSession={startSession}
      toggleBookmark={toggleBookmark}
    />
  );
};

const mapStateToProps = ({ session: { allSessions, mySessions, currentSession, currentLearningHubSessionProgress } }) => ({
  allSessions,
  mySessions,
  currentSession,
  sessionProgress: currentLearningHubSessionProgress
});

export default connect(mapStateToProps, {
  initSessions,
  initSession,
  startSession,
  toggleBookmark
})(SessionIntroductionContainer);
